var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page column-flex ac jc"},[_c('h1',[_vm._v("404 - 页面未找到")]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('p',[_vm._v("很抱歉，您访问的页面不存在。")]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }